import Image from "next/image";
import React from "react";

const WebmLoader = ({ src, width = 100, height = 100, loop = true }) => {
  const [show, setShow] = React.useState(false);

  React.useEffect(() => {
    const timer = setTimeout(() => {
      setShow(true);
    }, 4000); // 1 second delay

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="flex items-center flex-col justify-center h-screen w-screen bg-white dark:bg-black">
      <video
        width={width}
        height={height}
        autoPlay
        muted
        playsInline
        loop={loop}
        style={{ display: "block" }}
      >
        <source src={src} type="video/webm" />
        Your browser does not support the video tag.
      </video>
      {show && (
        <p className="text-base text-neutral-500 mb-4 px-4 text-center dark:text-neutral-300">
          It’s taking longer than usual. Please check your internet connection
          and try again.
        </p>
      )}
    </div>
  );
};

export default WebmLoader;
